import React from 'react';

export default function Home() {
  return (
    <div>
        <div className='page'>
            <div className='main_container'>
                <div className='chlid1'>
                    <h1 className='pagetitle'>Build a Perferct Health Growth</h1>
                    <div className='discription'>
                        Transform your fitness journey with personalized training, expert guidance, and sustainable results. Your best self starts here.
                    </div>
                    <a  className='button' href='https://wa.me/9082955754?text=Hello%20there!%20Myself planning to join your gym.%20Can we talk.'>JOIN NOW</a>
                </div>
                <div className='chlid2'>
                    <img className='models1' src='/images/models1.png' alt='Models1' />
                </div>
                <div className='chlid3'>
                    <div className='comment1'>
                        <img className='quote1' src='/images/quote-icon.svg' alt='Models1' />
                        <div className='commentdiscription1'>
                            An absolutely incredible fitness center! The trainers are knowledgeable and genuinely care about your progress. It's more than a gym—it's a supportive community that pushes you to be your best. Highly recommend!
                        </div>
                    </div>
                    <div className='comment2'>
                        <div className='greenbox'>
                            <img className='quote2' src='/images/woman-2592247_1280.jpg' alt='Models2' />
                            <h3>Stay Healthy by active</h3>
                            <div className='commentdiscription2'>Keep your body strong and energized through daily movement. Regular activity boosts immunity, improves mood, and increases longevity. Your journey to vibrant health starts with staying active every day.</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='main_container2'>
                <div className='glassmorfing'>
                    <div className='certified_trainers'>
                        <div className='count'>3</div>
                        <div className='title'>Certificate <br></br> trainer</div>
                    </div>
                    <div className='experience'>
                        <div className='count'>8</div>
                        <div className='title'>Years <br></br> Experience</div>
                    </div>
                    <div className='clients'>
                        <div className='count'>40+</div>
                        <div className='title'>Loyal <br></br> Client</div>
                    </div>
                </div>
            </div>
            <div className='main_container3'>
                <h1 className='pagetitle'>Benefits of Personal Training</h1>
                <div className='cardBox2'>
                    <div className='card2'>
                        <div class="button">Nutrition Strategies</div>
                        <div className='commentdiscription3'>
                            Get beyond the plan with continuous support from our coaches. We help you decode food labels, manage cravings, and stay motivated and accountable every step of the way.
                        </div>
                    </div>
                    <div className='card2'>
                        <div class="button">Work Routines</div>
                        <div className='commentdiscription3'>
                            Get beyond the plan with continuous support from our coaches. We help you decode food labels, manage cravings, and stay motivated and accountable every step of the way.
                        </div>
                    </div>
                    <div className='card2'>
                        <div class="button">Individual Support</div>
                        <div className='commentdiscription3'>
                            Get beyond the plan with continuous support from our coaches. We help you decode food labels, manage cravings, and stay motivated and accountable every step of the way.
                        </div>
                    </div>
                    <div className='card2'>
                        <div class="button">First-Hand Advice</div>
                        <div className='commentdiscription3'>
                            Get beyond the plan with continuous support from our coaches. We help you decode food labels, manage cravings, and stay motivated and accountable every step of the way.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}